"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @file IndexedDB compatibility checker
 */
function default_1() {
    if (!window) {
        throw new Error('idb-managed can not run in non-browser environment');
    }
    for (var _i = 0, _a = [
        'indexedDB',
        'IDBDatabase',
        'IDBObjectStore',
        'IDBTransaction',
        'IDBIndex',
        'IDBCursor',
        'IDBKeyRange',
        'IDBRequest'
    ]; _i < _a.length; _i++) {
        var property = _a[_i];
        // @ts-ignore
        if (!window.hasOwnProperty(property) || !window[property]) {
            throw new Error(property + " is not supported in window");
        }
    }
}
exports.default = default_1;
